import { TAnswerState } from '../../../../containers/FormContainer/types/internal';

export const areaFixedMapper = (answerState: TAnswerState) => {
  const value = answerState.value;

  return {
    [answerState.answerField]: {
      value,
    },
  };
};
